module.exports = __webpack_public_path__ + "img/penta5ex_bg.6f8ab051.png";